import { render, staticRenderFns } from "./SplitTestSetup.vue?vue&type=template&id=484353dd&scoped=true&"
import script from "./SplitTestSetup.vue?vue&type=script&lang=js&"
export * from "./SplitTestSetup.vue?vue&type=script&lang=js&"
import style0 from "./SplitTestSetup.vue?vue&type=style&index=0&id=484353dd&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484353dd",
  null
  
)

export default component.exports